import {
    STATUT_A_RECEPTIONNER,
    STATUT_DETENUE,
} from '../../../../../../utils/StatutsArme.constant';

export const BOUTON_SUPPRIMER = 'BOUTON_SUPPRIMER';
export const BOUTON_VALIDER_ACQUISITION = 'BOUTON_VALIDER_ACQUISITION';
export const BOUTON_PERDUE_VOLEE = 'BOUTON_PERDUE_VOLEE';
export const BOUTON_SIGNALER_ERREUR = 'BOUTON_SIGNALER_ERREUR';

export const listeBoutonsPossibles = (armes) => {
    if (armes.length === 0) {
        return [];
    }

    const listeBouton = [];
    const statutIdentiques = armes[0].statutId;
    let lettreEncodageIdentiques = armes[0].lettreEncodage;

    for (let i = 0; i < armes.length; i += 1) {
        if (armes[i].statutId !== statutIdentiques) {
            return [];
        }

        if (armes[i].lettreEncodage !== lettreEncodageIdentiques) {
            lettreEncodageIdentiques = null;
        }
    }

    if (statutIdentiques === STATUT_DETENUE) {
        listeBouton.push(BOUTON_PERDUE_VOLEE);
    }

    if (statutIdentiques === STATUT_A_RECEPTIONNER) {
        listeBouton.push(BOUTON_VALIDER_ACQUISITION);
    }

    if (lettreEncodageIdentiques === 'C' && statutIdentiques === STATUT_DETENUE) {
        listeBouton.push(BOUTON_SUPPRIMER);
    }

    if (
        armes.length === 1 &&
        lettreEncodageIdentiques === 'P' &&
        statutIdentiques === STATUT_DETENUE
    ) {
        listeBouton.push(BOUTON_SIGNALER_ERREUR);
    }

    return listeBouton;
};
